import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { bindAll } from '@bibliocommons/utils-react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import * as Icons from '@bibliocommons/deprecated-base-icons';

import './Checkbox.scss';

export class Checkbox extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  setCheckbox(el) {
    this._checkbox = el;
  }

  handleChange(e) {
    e.preventDefault();
    if (!this._checkbox) {
      return;
    }

    const { handleChange, name, value, checked } = this.props;
    handleChange(!checked, {
      name,
      value
    });
  }

  renderLabel() {
    return (
      <label
        id={`label_${this.props.id}`}
        htmlFor={this.props.id}
        data-test-id={this.props.labelTestId}
        className={cn('checkbox-label', {
          'label-before': this.props.labelBefore,
          'sr-only': this.props.srOnlyLabel,
          'disabled-label': this.props.disabled
        })}
      >
        {this.props.label}
      </label>
    );
  }

  renderFakeCheckbox() {
    let IconName = Icons[this.props.checked ? this.props.checkedIconName : this.props.uncheckedIconName];
    const iconProps = this.props.checked ? this.props.checkedIconProps : this.props.uncheckedIconProps;
    const buttonClassName = cn('check', {
      'no-borders': this.props.hideBorders,
      'hide-icon': !IconName,
      'checkbox-disabled': this.props.disabled
    });
    const iconClassName = cn('checkbox-icon', iconProps.className);
    const setFocusElement = el => {
      this._focusableElement = el;
    };

    if (!IconName) {
      IconName = Icons[this.props.checkedIconName];
    }

    return (
      <button
        type="button"
        className={buttonClassName}
        role="checkbox"
        aria-checked={this.props.checked}
        aria-labelledby={`label_${this.props.id}`}
        disabled={this.props.disabled}
        onClick={this.handleChange}
        ref={setFocusElement}
      >
        {IconName && <IconName {...iconProps} className={iconClassName} />}
      </button>
    );
  }

  render() {
    const { labelBefore, inline, variant, className, dataKey, ...props } = this.props;

    delete props.label;
    delete props.checkedIconName;
    delete props.checkedIconProps;
    delete props.uncheckedIconName;
    delete props.uncheckedIconProps;
    delete props.handleChange;
    delete props.labelTestId;
    delete props.hideBorders;
    delete props.srOnlyLabel;

    const classNames = cn('cp-deprecated-checkbox', { 'inline-checkbox': inline }, `checkbox-variant-${variant}`);

    return (
      <div className={classNames}>
        {labelBefore && this.renderLabel()}
        {!this.props.disabled && (
          <input
            type="checkbox"
            data-key={dataKey}
            ref={this.setCheckbox}
            className={cn('checkbox-input', className)}
            onChange={this.handleChange}
            aria-hidden
            {...props}
          />
        )}
        {this.renderFakeCheckbox()}
        {!labelBefore && this.renderLabel()}
      </div>
    );
  }
}

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  labelBefore: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]).isRequired,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, ImmutablePropTypes.map]),
  checked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  checkedIconName: PropTypes.string,
  checkedIconProps: PropTypes.objectOf(PropTypes.string, PropTypes.any),
  uncheckedIconName: PropTypes.string,
  uncheckedIconProps: PropTypes.objectOf(PropTypes.string, PropTypes.any),
  inline: PropTypes.bool,
  variant: PropTypes.oneOf(['primary', 'default', 'transparent']),
  hideBorders: PropTypes.bool,
  labelTestId: PropTypes.string,
  srOnlyLabel: PropTypes.bool,
  dataKey: PropTypes.string
};

Checkbox.defaultProps = {
  checked: false,
  checkedIconName: 'Checkmark',
  checkedIconProps: {},
  uncheckedIconProps: {},
  handleChange() {},
  inline: false,
  labelBefore: false,
  disabled: false,
  hideBorders: false,
  variant: 'primary',
  srOnlyLabel: false
};

export default Checkbox;
